<template>
  <div class="noData-container">
    <span>{{ tips }}</span>
  </div>
</template>

<script>

export default {
  name: 'NoData',
  props: {
    tips: {
      type: String,
      default: '抱歉，当前账号暂无查看充电宝后台的权限',
    },
  },
};
</script>

<style lang="scss" scoped>
.noData-container {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  padding-top: 312px;
  line-height: 42px;
  font-size: 30px;
  text-align: center;
  background: url('~@/assets/img/no-data@2x.png') no-repeat center top;
  background-size: 270px;
  color: rgba(0, 0, 0, .84);
  span {
    display: inline-block;
    max-width: 600px;
    text-align: left;
  }
}
</style>
